import * as angular from 'angular';

import { VirtualRepeaterCellComponent } from './VirtualRepeaterCellComponent';
import { VirtualRepeaterHeadingComponent } from './VirtualRepeaterHeadingComponent';
import { VirtualRepeaterRowComponent } from './VirtualRepeaterRowComponent';
import { VirtualRepeaterTableComponent } from './VirtualRepeaterTableComponent';

const virtualRepeaterModule = angular.module('app.areas.common.virtualRepeater', []);

virtualRepeaterModule
    .component(VirtualRepeaterCellComponent.$name, new VirtualRepeaterCellComponent())
    .component(VirtualRepeaterHeadingComponent.$name, new VirtualRepeaterHeadingComponent())
    .component(VirtualRepeaterRowComponent.$name, new VirtualRepeaterRowComponent())
    .component(VirtualRepeaterTableComponent.$name, new VirtualRepeaterTableComponent());

export default virtualRepeaterModule.name;
